import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';

import 'Container/GestionContrat/FicheContrat/FicheContrat.scss';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';

import { getDigit, getTypeLabel } from 'utils/stringUtils';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import {
    getRechercheDetailContrat,
    rechercheInfoComplementaires2
} from "../../../api/recherchePersonneService";
import { useDispatch, useSelector } from "react-redux";
import {
    clearContratsBeneficiaires, clearInfosComplementaires,
    updateContratsBeneficiaires, updateDemandeAcit, updateIdPersGrc,
    updateInfosComplementaires
} from "../../../Redux/gestionContrat/gestionContratReducer";
import { getCarteTp } from "../../../api/documentsGrcEvtService";
import { displayBase64Pdf } from "../../../utils/fileUtils";
import DOMPurify from "dompurify";
import moment from "moment";
import { envoiTrace } from "../../../api/techniqueEdclService";
import { isIndemnisationsAuthorized } from "../../../utils/metierUtils";
import PaginationWithTable from "../../../Components/PaginationWithTable/PaginationWithTable";

export default function FicheContrat() {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    // TODO récup le numContrat dans le contrat dans le reducer

    console.log("contrat")
    console.log(contrat)

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF.ROUTES;
    const PAGES = ROUTES?.PAGES;

    const [disabledPage, setDisablePage] = useState(false);
    const [carteTp, setCarteTp] = useState({
        pdfBase64: null,
        loaded: false,
        display: false
    })

    const [cotisations, setcotisations] =useState({
        echeances: [],
        display: false,
    })

    console.log("cotisations")
    console.log(cotisations)

    useEffect(() => {

        const fetchContratEtInfoComp = async () => {

            try {

                const respContratsBeneficiaires = await getRechercheDetailContrat(contrat?.numeroContrat)

                console.log("[[[[[[[[")
                console.log("respContratsBeneficiaires")
                console.log(respContratsBeneficiaires)

                dispatch(updateContratsBeneficiaires(respContratsBeneficiaires))

                const respInfoComp = await rechercheInfoComplementaires2(contrat?.numeroContrat, contrat?.dateAdhesionContrat)

                console.log("]]]]]]]")
                console.log("respInfoComp")
                console.log(respInfoComp)

                const echeances = respInfoComp?.echeances

                if (echeances?.length > 0 && Array.isArray(echeances)) {

                    setcotisations((prev) => ({
                        ...prev,
                        echeances: echeances
                    }))
                }


                dispatch(updateInfosComplementaires(respInfoComp))

            } catch (err) {

                // TODO test
                // navigate(PAGES?.RECHERCHE_PERSONNE)
            } finally {
                setDisablePage(false);
            }

            try {
                const carteTp = await getCarteTp(contrat?.numeroContrat)

                setCarteTp((prev) => ({
                    ...prev,
                    pdfBase64: carteTp.pdfBase64,
                    loaded: true,
                }))

            } catch (err) {

            }
        }

        if (contrat?.numeroContrat) {

            setDisablePage(true);

            fetchContratEtInfoComp().then()
        }

    }, []);

    useEffect(() => {

        if (keycloakReduce?.decodedToken?.idGrm){
            envoiTrace(keycloakReduce?.decodedToken?.idGrm,
                CONF?.CODES?.CODES_TRACES?.ACCES_CONTRAT,
                {
                    numeroContrat: contrat?.numeroContrat,
                })
        }

    }, [])

    const versFichePersonne = (idPersGrc) => {

        dispatch(clearContratsBeneficiaires())
        dispatch(clearInfosComplementaires())
        dispatch(updateIdPersGrc(idPersGrc))

        navigate(PAGES.FICHE_PERSONNE);
    }

    const versDemandeAcit = (contratPersonne) => {

        dispatch(updateDemandeAcit(contratPersonne))

        navigate(ROUTES?.PAGES?.DEMANDE_INDEMNISATION?.LISTE_INDEMNISATION)
    }

    const CotisationsTable = ({ data: echeances }) => {

        return (
            <div className='table-responsive'>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">Date</th>
                        <th className="text-center">Montant</th>
                    </tr>
                    </thead>
                    <tbody>
                    { echeances?.length > 0 && echeances.map(echeance => {

                        return (
                            <tr key={ uuidv4() }>
                                <td className="text-center">{ echeance?.dateExigibilite }</td>
                                <td className="text-center">{ echeance?.montant }</td>
                            </tr>
                        )
                    }) }

                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='container-fluid px-5 mt-3'>

            <SecondaryNavBar activePage='ficheContrat'/>

            <main id="content" className="mt-3 overlay-container">

                { disabledPage && <LoadingOverlay classes="upload-overlay"/> }

                <div className="row">
                    <div className="col-lg-6 mt-3">
                        <div className="card h-100">
                            <div className={ `card-header ${ contrat?.dateRadiationContrat ? 'header-annule' : "" }` }>
                                <div>
                                    <h1>{ contrat?.nomProduit }</h1>
                                    <h2>Contrat n°{ contrat?.numeroContrat }</h2>
                                    { contrat?.dateRadiationContrat &&
                                        <h3>Contrat résilié au : { contrat?.dateRadiationContrat }</h3> }
                                </div>
                                <div className='float-end'>
                                    <span>{ contrat?.gammeContrat }</span>
                                </div>

                            </div>
                            <div className={ `card-body ${ contrat?.dateRadiationContrat ? 'devis-annule' : "" }` }>
                                <h3>Informations souscripteur</h3>
                                <div className="row">
                                    <div className="col-md-12">
                                        <span>
                                            <span
                                                className='bold'>Civilité :</span> { infosComplementaires?.persCodeCivilite }
                                        </span>
                                    </div>
                                    <div className="col-md-6">
                                        <span>
                                            <span className='bold'>Nom :</span> { infosComplementaires?.persNom }
                                        </span>
                                    </div>
                                    <div className="col-md-6">
                                        <span>
                                            <span className='bold'>Prénom :</span> { infosComplementaires?.persPrenom }
                                        </span>
                                    </div>
                                    <div className="col-md-6">
                                        <span>
                                            <span
                                                className='bold'>Date de naissance :</span> { infosComplementaires?.persDateNaissance }
                                        </span>
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <span>*/}
                                    {/*        <span*/}
                                    {/*            className='bold'>Date de souscription :</span> { detailPersonne?.dateAdhesion }*/}
                                    {/*    </span>*/}
                                    {/*</div>*/}
                                </div>

                                <h3 className='mt-3'>Informations contrat</h3>
                                <div className="row">

                                    <div className="col-md-6">
                                        <span>
                                            <span
                                                className='bold'>Offre :</span> { contrat?.offre }
                                        </span>
                                    </div>
                                    <div className="col-md-6">
                                        <span>
                                            <span
                                                className='bold'>Typologie contrat :</span> { contrat?.typeContrat }
                                        </span>
                                    </div>
                                    <div className="col-md-6">
                                        <span>
                                            <span
                                                className='bold'>Date d'adhésion :</span> { contrat?.dateAdhesionContrat }
                                        </span>
                                    </div>
                                    { contrat?.gammeContrat === 'SANTE' && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Prévoyance en inclusion :</span> { contrat?.prevInclusion === "O" ? "oui" : "non" }
                                            </span>
                                        </div>
                                    )}
                                    { contrat?.dateChangementProduit && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Date de changement produit :</span> { contrat?.dateChangementProduit }
                                            </span>
                                        </div>
                                    ) }

                                    { contrat?.nomAncienProduit && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Nom ancien produit :</span> { contrat?.nomAncienProduit }
                                            </span>
                                        </div>
                                    ) }

                                    { contrat?.motifResiliationContrat && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Date résiliation :</span> { contrat?.motifResiliationContrat }
                                            </span>
                                        </div>
                                    ) }

                                    { contrat?.minoration && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Minoration :</span> { getDigit(contrat?.minoration) } %
                                            </span>
                                        </div>
                                    ) }

                                    { contrat?.dateRadiationContrat ? (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Date résiliation :</span> { contrat?.dateRadiationContrat }
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="col-md-6">
                                            <span>Pas de résiliation en cours sur ce contrat.</span>
                                        </div>
                                    ) }
                                </div>

                                <h3 className='mt-3'>Mode de règlement</h3>
                                <div className="row">
                                    <div className="col-md-6">
                                        <span>
                                            <span
                                                className='bold'>Mode de règlement :</span> { infosComplementaires?.modeReglementAC }
                                        </span>
                                    </div>

                                    { infosComplementaires?.modeReglementAC !== "CHEQUE" && (
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Jour de prélèvement :</span> { infosComplementaires?.codeEcheancierPaiementAC }
                                            </span>
                                        </div>
                                    ) }

                                </div>

                                <h3 className='mt-3'>Informations bancaires</h3>
                                <div className="col-12">
                                    <span>
                                        <span
                                            className='bold'>Titulaire du compte :</span> { infosComplementaires?.ribTitulaireCompte }
                                    </span>
                                </div>

                                <div className="ms-3">
                                    <h4 className='mt-2'>RIB</h4>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Banque :</span> { infosComplementaires?.ribCodeBanque }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Guichet :</span> { infosComplementaires?.ribCodeGuichet }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>N° du compte :</span> { infosComplementaires?.ribNumeroCompte }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Clé RIB :</span> { infosComplementaires?.ribCle }
                                            </span>
                                        </div>
                                    </div>
                                    <h4 className='mt-2'>IBAN</h4>
                                    <div className='col-12'>
                                        <span>
                                            <span
                                                className='bold'>Numéro IBAN :</span> { infosComplementaires?.ribIdentifiantNationalCompte }
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="card-footer d-flex justify-content-between">
                                <button className="btn btn-primary ms-2"
                                        type="button"
                                        onClick={ () => setcotisations((prev) => ({
                                            ...prev,
                                            display: !prev?.display,
                                        })) }>
                                    { cotisations?.display ? "Masquer le récapitulatif" : "Récapitulatif des cotisations" }
                                </button>
                                <button className="btn btn-secondary ms-2"
                                        type="button"
                                        onClick={ () => setCarteTp((prev) => ({
                                            ...prev,
                                            display: !prev?.display,
                                        })) }>
                                    { carteTp?.display ? "Masquer la carte tiers payant" : "Afficher la carte tiers payant" }
                                </button>
                            </div>
                        </div>
                    </div>

                    { cotisations?.display && (
                        <div className="col-lg-6 mt-3">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h1>Dernières cotisations</h1>
                                </div>
                                <div className={ "card-body" }>
                                    { cotisations?.echeances?.length > 0 ? (
                                        <PaginationWithTable
                                            key={ cotisations?.echeances?.length }
                                            records={ cotisations?.echeances }
                                            recordsPerPage={ 12 }
                                            TableComponent={ CotisationsTable }
                                        />
                                    ) : (
                                        <div>
                                            Pas de cotisations à afficher
                                        </div>
                                    ) }
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <button className="btn btn-primary ms-2"
                                            type="button"
                                            onClick={ () => setcotisations((prev) => ({
                                                ...prev,
                                                display: !prev?.display,
                                            })) }>
                                        { cotisations?.display ? "Masquer le récapitulatif" : "Récapitulatif des cotisations" }
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) }

                    { carteTp?.display && (
                        <div className="col-lg-6 mt-3">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h1>Carte tiers payant</h1>
                                </div>
                                <div className={ "card-body" }>
                                    { carteTp?.pdfBase64 ? (
                                        <>

                                            <div className='my-2'>
                                                <a
                                                    href={ displayBase64Pdf(carteTp?.pdfBase64) }
                                                    download={ `Carte tiers payant ${ infosComplementaires?.persPrenom } ${ infosComplementaires?.persNom } - ${ moment().year() }.pdf` }
                                                    dangerouslySetInnerHTML={ {
                                                        __html: DOMPurify.sanitize(`Télécharger carte tiers payant ${ infosComplementaires?.persPrenom } ${ infosComplementaires?.persNom } - ${ moment().year() }`)
                                                    } }/>
                                            </div>
                                            <object
                                                id="affichage-ba"
                                                type="application/pdf"
                                                width="100%"
                                                height="800"
                                                // data={ `data:application/pdf;base64,${ carteTp }` }
                                                data={ displayBase64Pdf(carteTp?.pdfBase64) }
                                            />
                                        </>
                                    ) : (
                                        <p>{ carteTp?.loaded ? "Pas de carte tiers payant disponible" : "Chargement du PDF..." }</p>
                                    ) }
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <button className="btn btn-secondary ms-2"
                                            type="button"
                                            onClick={ () => setCarteTp((prev) => ({
                                                ...prev,
                                                display: false,
                                            })) }>
                                        Masquer la carte tiers payant
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) }

                    <div className="col-lg-6 mt-3">
                        <div className="card h-100">
                            <div className="card-header">
                                <h1>Bénéficiaires</h1>
                            </div>
                            <div className="card-body">

                                <div className="row">
                                    { Array.isArray(contratsBeneficiaires) && contratsBeneficiaires?.map(contratBeneficiaire => (
                                        // eslint-disable-next-line react/jsx-key
                                        <div key={ uuidv4() } className="col-md-6 mt-3">
                                            <div className="card h-100">
                                                <div className="card-header header-rose">
                                                    <h4 aria-level={ 2 }>{ getTypeLabel(contratBeneficiaire?.typeIndividu) }</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div>
                                                        <span>
                                                            <span
                                                                className='bold'>Civilité :</span> { contratBeneficiaire?.civilite }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>
                                                            <span className='bold'>Nom :</span> { contratBeneficiaire?.nom }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>
                                                            <span className='bold'>Prénom :</span> { contratBeneficiaire?.prenom }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>
                                                            <span
                                                                className='bold'>Date adhésion :</span> { contratBeneficiaire?.dateAdhesion }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>
                                                            { contratBeneficiaire?.dateRadiation ? (
                                                                <>
                                                                    <span
                                                                        className='bold'>Date de radiation :</span> { contratBeneficiaire?.dateRadiation }
                                                                </>
                                                            ) : (
                                                                <>Pas de radiation en cours sur ce membre.</>
                                                            ) }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>
                                                            { contratBeneficiaire?.motifRadiation && (
                                                                <>
                                                                    <span
                                                                        className='bold'>Motif de radiation :</span> { contratBeneficiaire?.motifRadiation }
                                                                </>
                                                            ) }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="row justify-content-end d-flex">
                                                        { isIndemnisationsAuthorized(contrat?.produit) && (
                                                            <button className="btn btn-secondary col"
                                                                    type="button"
                                                                    onClick={ () => versDemandeAcit(contratBeneficiaire) }>
                                                                Demande d'indémnisation
                                                            </button>
                                                        ) }
                                                        <button
                                                            className="btn btn-primary col mt-0 ms-2"
                                                            onClick={ () => versFichePersonne(contratBeneficiaire?.idPersGrc) }>
                                                            Voir la fiche individu
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )) }
                                </div>
                            </div>
                            <div className="card-footer d-flex justify-content-end">
                                <button className="btn btn-secondary ms-2"
                                        type="button"
                                        onClick={ () => navigate(ROUTES?.PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_ADRESSE) }>
                                    Demande de modification
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}